var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "animated fadeIn features" },
      [
        _c(
          "b-card",
          { staticClass: "received-form", attrs: { "no-body": "" } },
          [
            _c(
              "div",
              { staticClass: "features-table" },
              [
                _c("SearchBar", {
                  attrs: {
                    editedOptions: _vm.editedOptions,
                    editedByValue: _vm.editedByValue,
                    title: "Features Flags"
                  },
                  on: {
                    filterInput: _vm.setFilter,
                    "update:editByValue": _vm.editByUserName
                  }
                }),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    "show-empty": "",
                    striped: "",
                    "empty-text": _vm.$t("COMMON.NO_RECORD"),
                    hover: "",
                    responsive: "sm",
                    variant: "danger",
                    items: _vm.sortedFeatureFlags,
                    filter: _vm.filter,
                    fields: _vm.tableFields,
                    "sort-by": _vm.sortBy,
                    "sort-desc": _vm.sortDesc
                  },
                  on: {
                    "update:sortBy": function($event) {
                      _vm.sortBy = $event
                    },
                    "update:sortDesc": function($event) {
                      _vm.sortDesc = $event
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "HEAD_is_enabled",
                      fn: function(data) {
                        return [_c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])]
                      }
                    },
                    {
                      key: "is_enabled",
                      fn: function(data) {
                        return [
                          _c("cSwitch", {
                            attrs: {
                              type: "3d",
                              variant: "success",
                              checked: data.item.is_enabled
                            },
                            on: {
                              change: function($event) {
                                _vm.updateIndividualFeatureFlag(
                                  $event,
                                  data.item
                                )
                              }
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-298ce48b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-298ce48b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/featureflag/FeatureFlag.vue
// module id = 1283
// module chunks = 2